var React = require('react');

function AvatarFoundations (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#00c7e6","height":"24","rx":"3","width":"24","key":0}),React.createElement("path",{"d":"m14.856 13.228v-1.296h-3.48v-2.52h3.84v-1.296h-5.28v7.884h1.44v-2.772z","fill":"#fff","key":1})]);
}

AvatarFoundations.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = AvatarFoundations;

AvatarFoundations.default = AvatarFoundations;
